import { productsController } from 'reactApp/modules/products/products.controller';
import { ProductsSelectors } from 'reactApp/modules/products/products.selectors';
import { put, take } from 'redux-saga/effects';
import { select } from 'typed-redux-saga';

import { handleBillingDataSuccess } from './billingData.handler.saga';
import { getBillingDataRequest, getBillingDataSuccess } from './billingData.module';
import { BillingDataSelectors } from './billingData.selectors';
import type { BillingDataSubscriptionInfo } from './billingData.types';

export function* loadBillingDataIfNotLoaded() {
    const { isLoaded, isLoading } = yield* select(BillingDataSelectors.getBillingDataLoadingState);

    if (!isLoaded && !isLoading) {
        yield put(getBillingDataRequest({ radar: 'subs' }));
    }

    return yield handleBillingDataSuccess();
}

export function* loadBillingDataSubscriptionById(subscriptionId: string | number) {
    let subscription = yield* select(BillingDataSelectors.getSubscriptionsById, subscriptionId);

    if (!subscription) {
        yield put(getBillingDataRequest({ radar: 'subs' }));
        yield take(getBillingDataSuccess);
    }

    subscription = yield* select(BillingDataSelectors.getSubscriptionsById, subscriptionId);
    return subscription as BillingDataSubscriptionInfo;
}

export function* loadSubscriptionProducts() {
    // загружаем биллинг дату
    yield loadBillingDataIfNotLoaded();

    // загружаем продукты
    yield productsController.loadProducts();

    const subscriptions: BillingDataSubscriptionInfo[] = yield select(BillingDataSelectors.getSubscriptionsList);
    return yield* select((state) =>
        ProductsSelectors.getAvailableProductsByListIds(
            state,
            subscriptions.map((item) => item.productId)
        )
    );
}
